import type { MouseEvent } from 'react';

/**
 * Click handler for a link with target="_blank". Some embedded browser panels ignore
 * target="_blank" on a plain link, so the tab is opened from the click instead; a normal
 * browser behaves the same either way. Modified clicks (cmd, ctrl, shift, middle) are left
 * to the browser.
 */
export function openInNewTab(e: MouseEvent<HTMLAnchorElement>): void {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  const href = e.currentTarget.href;
  if (!href) return;
  e.preventDefault();
  window.open(href, '_blank', 'noopener,noreferrer');
}
